import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'

  return {
    formControl: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      width: '100%',
      '& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root.MuiOutlinedInput-marginDense':
        {
          minHeight: '25px',
          padding: '0 4px',
          '& .MuiOutlinedInput-input': {
            padding: '6px 4px !important'
          }
        },
      '& .MuiOutlinedInput-root': {
        minHeight: '25px',
        padding: '0 4px',
        backgroundColor: isDark
          ? theme.palette.dark_400.main + '!important'
          : theme.palette.gray_50.main + '!important',
        borderRadius: '8px',
        '& .MuiOutlinedInput-input': {
          padding: '2px 4px !important',
          color: isDark
            ? theme.palette.dark_50.main + '!important'
            : theme.palette.gray_400.main + '!important'
        },
        '& .MuiChip-root': {
          color: isDark
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main
        },
        '& .MuiAutocomplete-popupIndicator': {
          color: isDark
            ? theme.palette.dark_50.main + '!important'
            : theme.palette.gray_400.main + '!important'
        },
        '& .MuiAutocomplete-clearIndicator': {
          color: isDark
            ? theme.palette.dark_50.main + '!important'
            : theme.palette.gray_400.main + '!important'
        }
      },
      '& label': {
        color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
      }
    },
    chip: {
      borderRadius: '4px',
      textTransform: 'uppercase',
      height: '20px',
      fontSize: '11px'
    },
    chipPlus: {
      height: '20px',
      fontSize: '11px',
      padding: '0 2px',
      borderRadius: '4px',
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main + '!important'
    },
    iconButton: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },
    checkbox: {
      marginRight: 8,
      padding: 0,
      color: isDark
        ? theme.palette.dark_50.main + '!important'
        : theme.palette.gray_400.main + '!important',
      '&.Mui-checked': {
        color: theme.palette.blue_300.main + '!important'
      },
      '& .MuiSvgIcon-root': {
        color: 'inherit'
      }
    },
    listbox: {
      maxHeight: '200px',
      overflowY: 'auto',
      ...theme.scrollbarStyles,
      '& .MuiAutocomplete-option': {
        padding: '0px 8px',
        margin: '0',
        color: isDark
          ? theme.palette.dark_50.main + '!important'
          : theme.palette.gray_400.main + '!important',
        '&:not(.Mui-selected)': {
          color: isDark
            ? theme.palette.dark_50.main + '!important'
            : theme.palette.gray_400.main + '!important'
        }
      }
    }
  }
})
